import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  getUsersAwaitingVerification,
  VerificationFilterType,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";
import type { AwaitingVerificationParams } from "Api/Queries/User/awaitingVerificationTypes";

const USERS_AWAITING_BANK_QUERY_KEY = "USERS_AWAITING_BANK";

export const usersAwaitingBankKeys = {
  all: [USERS_AWAITING_BANK_QUERY_KEY],
  byParams: (params: AwaitingVerificationParams) => [
    ...usersAwaitingBankKeys.all,
    params,
  ],
};

type QueryOptions = {
  enabled?: boolean;
  params?: AwaitingVerificationParams;
};

export const useUsersAwaitingBankQuery = ({
  enabled,
  params,
}: QueryOptions = {}) =>
  useQuery({
    queryKey: usersAwaitingBankKeys.byParams(params ?? {}),
    queryFn: processResponseWithApiProblemDetails(() =>
      getUsersAwaitingVerification(
        VerificationFilterType.BankAccountVerification,
        params?.login,
        params?.firstName,
        params?.lastName,
        params?.companyName,
        params?.companyNumber,
        params?.roleCodes,
        params?.offset,
        params?.limit,
        params?.sortBy,
        params?.sortDirection,
      ),
    ),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    staleTime: MS_TIME.minute,
    enabled,
  });
